import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Expense Reports by Vehicle</h3>
                <p className="text-sm text-gray-600">
                    Analyze fleet costs on a per-vehicle basis to identify high-maintenance units.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Filtering Options</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Date Range:</strong> Narrow down expenses to a specific timeframe.</li>
                    <li><strong>Vendor:</strong> View costs associated with a particular service provider.</li>
                    <li><strong>User:</strong> See expenses logged or authorized by specific team members.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Data Visualization</h4>
                <p className="text-sm text-gray-600">
                    The report aggregates total spending and displays it across all vehicles. Use the search bar to zoom into a specific vehicle's historical costs.
                </p>
            </section>
        </div>
    );
};

export default Help;
